import queryString from "query-string";

/**
 * Application configuration singleton
 */
class AppConfig {
  private static config: AppConfig | null = null;

  readonly isProduction = import.meta.env.MODE === "production";
  readonly isIframed = window.self !== window.top;
  readonly apiBaseUrl = import.meta.env.VITE_API_BASE_URL;
  readonly wsCluster = import.meta.env.VITE_WS_CLUSTER;
  readonly wsKey = import.meta.env.VITE_WS_KEY;
  readonly wsHost = import.meta.env.VITE_WS_HOST;
  readonly wsPort = import.meta.env.VITE_WS_PORT;
  readonly fsOrgId = import.meta.env.VITE_FS_ORG_ID;
  readonly posthogApiKey = import.meta.env.VITE_POSTHOG_API_KEY;
  readonly feedbackChannel = import.meta.env.VITE_SLACK_FEEDBACK_CHANNEL;
  readonly sentryDsn = import.meta.env.VITE_SENTRY_DSN;
  readonly isHttps: boolean = this.apiBaseUrl?.startsWith("https") ?? false;

  readonly token: string;
  readonly email: string;
  readonly target: string;
  readonly branding: string;
  readonly emailBranding: string;
  readonly page: string;
  readonly platformTemplateId: string;
  readonly embedWidgetOnBoot: boolean;

  /** Auth attributes */
  readonly secret: string;
  readonly jwt: string;

  private constructor() {
    const parsed = queryString.parse(location.search);
    this.token = parsed.token?.toString() ?? "";
    this.secret = parsed.secret?.toString() ?? "";
    this.email = parsed.email?.toString() ?? "";
    this.target = parsed.target?.toString() ?? "";
    this.jwt = parsed.jwt?.toString() ?? "";
    this.branding = parsed.branding?.toString() ?? "";
    this.emailBranding = parsed.emailBranding?.toString() ?? "";
    this.page = parsed.page?.toString() ?? "";
    this.platformTemplateId = parsed.borrowerPlatformTemplate?.toString() ?? "";
    this.embedWidgetOnBoot = Boolean(parsed.embedWidgetOnBoot);
  }

  public static get instance(): AppConfig {
    if (!this.config) {
      this.config = new AppConfig();
    }
    return this.config;
  }

  public get isEmbedded() {
    return this.isIframed && this.target;
  }

  public get isWidget() {
    return this.isIframed && !this.target;
  }
}

export default AppConfig.instance;
